import "./__content.scss"; import "./__form.scss"; import "./structured_data_module.scss"
import "./__content.coffee"; import "./__form.coffee"; import "./structured_data_module.coffee"
